<template>
  <div class="videoIncome-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input placeholder="请输入视频发布者ID" v-model="params.uid" size="small" @keyup.enter.native="getVIncome('status')" clearable class="param-input"></el-input>
       <el-input placeholder="视频ID" v-model="params.vid" size="small" @keyup.enter.native="getVIncome('status')" clearable class="param-input"></el-input>
      <el-date-picker v-model="time" type="datetimerange" @change="changeTime" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="small">
      </el-date-picker>
      <el-button type="primary" size="small" @click="getVIncome('status')">搜索</el-button>
      <el-button type="primary" size="small" @click="exportdata">导出</el-button>
      <!--博主总收益,输入博主id查询时才显示-->
      <span style="color:red;font-size:18px;margin-left:100px;">
        {{zIncomeBool?"总收益: ":""}}
        {{zIncomeBool?zIncome/100:""}}
      </span>
    </div>
    <!--表格数据-->
    <el-table max-height="650" :data="tableData" style="width: 100%" border @sort-change="handleSortChange" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" ref="multipleTable">
      <el-table-column prop="sumDate" label="增加时间" align="center" min-width="240">
        <template slot-scope="scope">
          <span>{{scope.row.sumDate | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="video.publisherID" label="视频发布者ID" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{scope.row.video.publisherID || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="video.publisherName" label="视频发布者姓名" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{scope.row.video.publisherName || '-'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="video.id" label="视频ID" align="center" min-width="240">
        <template slot-scope="scope">
          <span>{{scope.row.video.id || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="video.title" label="视频标题" align="center" min-width="360" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{scope.row.video.title || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="video.coins" label="定价" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{(scope.row.video.coins/100 || '0') | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="tax" label="扣税金额" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{(scope.row.tax/100 || '0') | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="income" label="当日收入" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{(scope.row.income/100 || '0') | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="day" label="售卖天数" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{scope.row.video.day}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="playCount" label="购买数" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{(scope.row.payCount || 0) | numFormat}}</span>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[10, 15, 20, 30]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
  </div>
</template>
<script>
import baseConfig from '@/utils/serverUrlConfig'
import {changeTime, paramsFilter, sortEscape} from '@/utils/global'
import API from '@/api'

export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      tableData: [],
      total: 0,
      time: '',
      zIncome: 0,
      zIncomeBool: false,
      // 视频收入统计请求参数
      params: {
        pageNumber: 1,
        pageSize: 20,
        // 排序条件值
        key: '',
        value: '',
        uid: '',
        // 开始结束时间
        startTime: '',
        endTime: ''
      }
    }
  },
  created() {
    this.getVIncome()
  },
  methods: {
    // 时间选择回掉
    changeTime(time) {
      if (time) {
        this.params.startTime = changeTime(time[0]) || ''
        this.params.endTime = changeTime(time[1]) || ''
      } else {
        this.params.startTime = ''
        this.params.endTime = ''
      }
      this.getVIncome()
    },
    // 请求用户列表
    getVIncome(type) {
      if (type) {
        this.params.pageNumber = 1
      }
      if (this.params.uid == '') {
        this.zIncome = 0
        this.zIncomeBool = false
      }
      this.loading = true
      API.getVIncomeList(this.params).then(res => {
        if (res.code === 200 && res.data.list) {
          this.tableData = res.data.list
          this.total = res.data.total
          //计算总收入
          if (this.params.uid != '') {
            var zIncome = 0
            for (let i = 0; i < res.data.list.length; i++) {
              zIncome += res.data.list[i].income
            }
            this.zIncome = zIncome
            this.zIncomeBool = true
          }
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.tableData = []
        this.total = 0
        this.loading = false
      })
    },
    // 导出数据
    exportdata() {
      let params = paramsFilter(this.params)
      let str = ''
      for(let key in params) {
         if(key == "startTime" || key == "endTime" ) {
          params[key] = params[key].replace('+','%2B')
        } 
         str += key + "=" + params[key] + "&"
      }
      str = str.substring(0,str.length-1)
      let url = baseConfig.baseServerUrl + "/export/videoIncome?" + str
      window.location.href = url
    },
    // 数据排序
    handleSortChange(column) {
      this.params.value = sortEscape(column.order)
      this.params.key = column.prop;
      this.getVIncome()
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.params.pageSize = size
      this.params.pageNumber = 1
      this.getVIncome()
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber
      this.getVIncome()
    },
  }
}
</script>
